<template>
	<b-modal ref="topes-multiples-modal" size="xmd" hide-footer scrollable no-close-on-backdrop no-close-on-esc>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Topes Múltiples</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button
						variant="flat-primary"
						@click="showDaysWithoutTopesModal = true"
						v-b-tooltip.hover="'Ver Ejemplares sin Topar'"
					>
						<img src="/training/icon.svg" alt="" class="" style="width: 24px; margin-right: 0.5rem" />
					</b-button>
					<b-button variant="outline-primary" v-b-tooltip.hover="'Agregar Tope'" @click="addTope">
						<FeatherIcon icon="PlusIcon"></FeatherIcon>
					</b-button>
					<b-button variant="success" v-b-tooltip.hover="'Guardar'" @click="saveTopes">
						<FeatherIcon icon="SaveIcon"></FeatherIcon>
					</b-button>
					<b-button variant="danger" @click="$emit('close')" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<div style="min-height: 600px">
				<b-card class="sticky-header">
					<b-row>
						<b-col class="d-flex font-weight-bold justify-content-center">#</b-col>
						<b-col class="d-flex font-weight-bold justify-content-center">Tipo</b-col>
						<b-col class="d-flex font-weight-bold justify-content-center">
							Ejemplar #1
							<v-icon
								name="gi-boxing-glove"
								scale="1.3"
								class="ml-1 text-danger"
								style="transform: rotate(270deg)"
							/>
						</b-col>
						<b-col class="d-flex font-weight-bold justify-content-center">
							Ejemplar #2
							<v-icon
								name="gi-boxing-glove"
								scale="1.3"
								class="ml-1"
								style="transform: rotate(270deg); color: blue"
							/>
						</b-col>
						<b-col class="d-flex font-weight-bold justify-content-center">Acción</b-col>
					</b-row>
				</b-card>
				<div v-if="topes.length === 0" class="text-center mt-3">
					<p>No hay topes agregados</p>
				</div>
				<b-card v-for="(tope, index) in topes" :key="`tope-${index}`" class="mb-2">
					<b-row>
						<b-col class="d-flex align-items-center justify-content-center">
							{{ topes.length - index }}
						</b-col>
						<b-col class="d-flex align-items-center">
							<v-select
								v-model="tope.type"
								:options="typeOpts"
								:clearable="false"
								placeholder="Elegir tipo"
								label="label"
								class="w-100"
								:reduce="(option) => option.value"
								:disabled="isInputLoading"
								@input="handleChangeFighters(tope, index, true)"
							/>
						</b-col>

						<b-col class="d-flex align-items-center">
							<v-select
								v-model="tope.local_id"
								:options="tope.specimenLocalOptions"
								:clearable="false"
								placeholder="Buscar ejemplar"
								@search="(search) => debouncedGetSpecimens(tope, 'local', search)"
								label="plate"
								class="w-100"
								:reduce="(option) => option.id"
								:disabled="isInputLoading"
								@input="handleChangeFighters(tope, index)"
							>
								<template slot="no-options">Sin ejemplares encontrados</template>

								<template slot="option" slot-scope="option">
									<div class="d-center">
										{{ `${option.plate} - ${option.alias || "Sin Alias"}` }}
									</div>
								</template>
								<template slot="selected-option" slot-scope="option">
									<div class="selected d-center">
										{{ `${option.plate} - ${option.alias || "Sin Alias"}` }}
									</div>
								</template>
							</v-select>
							<FeatherIcon
								v-if="tope.local_id"
								icon="EyeIcon"
								class="text-warning cursor-pointer ml-1"
								size="18"
								@click="openDetails({ id: tope.local_id })"
							/>
						</b-col>

						<b-col class="d-flex align-items-center">
							<v-select
								v-if="tope.type === 1"
								v-model="tope.rival_id"
								:options="tope.specimenRivalOptions"
								:clearable="false"
								placeholder="Buscar ejemplar"
								@search="(search) => debouncedGetSpecimens(tope, 'rival', search)"
								label="plate"
								class="w-100"
								:reduce="(option) => option.id"
								:disabled="isInputLoading"
								@input="handleChangeFighters(tope, index)"
							>
								<template slot="no-options">Sin ejemplares encontrados</template>

								<template slot="option" slot-scope="option">
									<div class="d-center">
										{{ `${option.plate} - ${option.alias || "Sin Alias"}` }}
									</div>
								</template>
								<template slot="selected-option" slot-scope="option">
									<div class="selected d-center">
										{{ `${option.plate} - ${option.alias || "Sin Alias"}` }}
									</div>
								</template>
							</v-select>
							<v-select
								v-else-if="tope.type === 2"
								v-model="tope.rival_id"
								:options="rivalOpts"
								:clearable="false"
								placeholder="Buscar rival"
								label="name"
								class="w-100"
								:reduce="(option) => option.id"
								:disabled="isInputLoading"
								@input="handleChangeFighters(tope, index)"
							/>
							<div v-else class="text-muted text-center">
								Seleccione un tipo para ver los rivales disponibles
							</div>
							<FeatherIcon
								v-if="tope.type === 1 && tope.rival_id"
								icon="EyeIcon"
								class="text-warning cursor-pointer ml-1"
								size="18"
								@click="openDetails({ id: tope.rival_id })"
							/>
						</b-col>

						<b-col class="d-flex align-items-center justify-content-center">
							<b-button
								variant="danger"
								size="sm"
								class="ml-1"
								@click="deleteTope(tope, index)"
								v-b-tooltip.hover="'Eliminar Tope'"
							>
								<feather-icon icon="Trash2Icon" size="20" />
							</b-button>
						</b-col>
					</b-row>
				</b-card>
				<div style="height: 300px"></div>
			</div>
		</b-overlay>
		<SpecimenSpecificDetailsModal
			v-if="showSpecificDetailsModal"
			:generalInfo="selectedSpecimen"
			@close="showSpecificDetailsModal = false"
		/>
		<DaysWithoutTopesModal v-if="showDaysWithoutTopesModal" @close="showDaysWithoutTopesModal = false" />
	</b-modal>
</template>

<script>
import specimenService from "@/services/specimens.service.js"
import debounce from "lodash/debounce"
import ConfrontationDraftsService from "@/views/amg/videolibrary/confrontation-drafts/services/confrontation-drafts.service.js"
import rivalService from "@/services/rivals.service.js"
import SpecimenSpecificDetailsModal from "@/components/specimens/SpecimenSpecificDetailsModal.vue"
import DaysWithoutTopesModal from "@/views/amg/preparacion/components/DaysWithoutTopesModal.vue"
export default {
	components: {
		SpecimenSpecificDetailsModal,
		DaysWithoutTopesModal,
	},
	name: "TopesMultiplesModal",
	props: {},
	data: () => ({
		typeOpts: [
			{ label: "Interno", value: 1 },
			{ label: "Externo", value: 2 },
		],
		search: "",
		isLoading: false,
		topes: [],
		debouncedGetSpecimens: null,
		selectedSpecimen: null,
		showSpecificDetailsModal: false,
		rivalOpts: [],
		showDaysWithoutTopesModal: false,
		isInputLoading: false,
	}),
	methods: {
		handleChangeFighters(tope, index, isTypeSelect) {
			if (isTypeSelect) {
				tope.rival_id = null
				tope.specimenRivalOptions = []
				return
			}
			if (tope.local_id && tope.rival_id && index == 0) {
				this.addTope()
			}
			if (tope.local_id && tope.rival_id && tope.type) {
				this.upsert(tope)
			}
		},
		openDetails(specimen) {
			this.selectedSpecimen = specimen
			this.showSpecificDetailsModal = true
		},
		async deleteTope(tope, index) {
			this.topes.splice(index, 1)
			if (!tope.id) return
			try {
				this.isInputLoading = true
				await ConfrontationDraftsService.destroy(tope.id)
			} catch (error) {
				console.error("Error al eliminar tope:", error)
			} finally {
				this.isInputLoading = false
			}
		},
		async upsert(tope) {
			try {
				this.isInputLoading = true
				const { data } = await ConfrontationDraftsService.upsert(tope)
				tope.id = data
			} catch (error) {
				console.error("Error al actualizar tope:", error)
			} finally {
				this.isInputLoading = false
			}
		},
		async getDrafts() {
			try {
				const { data } = await ConfrontationDraftsService.getDrafts()
				this.topes = data
			} catch (error) {
				console.error("Error al actualizar tope:", error)
			}
		},
		async saveTopes() {
			this.topes = this.topes.filter((tope) => tope.local_id && tope.rival_id && tope.type)
			if (this.topes.length === 0) {
				this.showToast(
					"warning",
					"top-right",
					"No es posible guardar",
					"InfoIcon",
					"Debe agregar al menos un tope completo"
				)
				return
			}
			const { isConfirmed } = await this.showConfirmSwal({
				title: "Guardar Topes",
				text: "¿Estás seguro de que deseas guardar los topes?",
			})
			if (!isConfirmed) return
			try {
				const params = {
					topes: this.topes.map((tope, index) => ({
						order: index + 1,
						type: tope.type,
						local_id: tope.local_id,
						rival_id: tope.rival_id,
					})),
				}
				this.isLoading = true
				await ConfrontationDraftsService.store(params)
				this.showSuccessToast("Topes guardados correctamente")
				this.topes = []
				this.$emit("refresh")
				this.$emit("close")
			} catch (error) {
				console.error("Error guardando topes:", error)
			} finally {
				this.isLoading = false
			}
		},
		handleInputSearch(value) {
			if (!value) return
			const exists = this.selectedOptions.some((option) => option.id === value.id)
			if (!exists) this.selectedOptions.push(value)
		},
		async getRivals() {
			const data = await rivalService.getRivals()
			this.rivalOpts = data
		},
		async getSpecimens(tope, type, search) {
			if (!search) return
			const { data } = await specimenService.getSpecimensToFight(search)
			tope[type == "local" ? "specimenLocalOptions" : "specimenRivalOptions"] = data.map((item) => ({
				id: item.id,
				plate: item.plate,
				alias: item.alias,
			}))
		},
		addTope() {
			const lastTope = this.topes.length ? this.topes[0] : null
			this.topes.unshift({
				id: null,
				local_id: null,
				rival_id: lastTope && lastTope.type === 2 ? lastTope.rival_id : null,
				type: lastTope ? lastTope.type : null,
				specimenLocalOptions: [],
				specimenRivalOptions: [],
			})
		},
	},
	watch: {},
	async mounted() {
		await this.getDrafts()
		this.getRivals()
		this.addTope()
		this.$refs["topes-multiples-modal"].toggle()
	},
	created() {
		this.debouncedGetSpecimens = debounce(this.getSpecimens, 500)
	},
}
</script>
<style lang="scss" scoped>
.sticky-header {
	position: sticky;
	top: 0;
	z-index: 1020;
	background-color: white;
	border-bottom: 2px solid #dee2e6;
}
</style>
